import type { TrialInDatabaseForAlgolia } from '../types/TrialInDatabaseForAlgolia'
import { isEarlyPhase1, isPhase1 } from './getPhaseFromPhaseList'

export default function hasNoCostForTreatment(
  trial: TrialInDatabaseForAlgolia,
) {
  return isEarlyPhase1(trial.phaseList) || isPhase1(trial.phaseList)
}
